import { isMaxLength, isRequiredField, validateRules } from '@foradevelopment/fora-ui';

import { typedT } from '../../../i18n/i18n';
import { isValidSwedishPostalCodeFormat } from './helpers/isValidSwedishPostalCodeFormat';

export const validatePostalCodeSweden = (value: string) => {
  // Only return one error message if value is missing altogether
  const isRequiredValidation = isRequiredField(typedT('errorMessages.validation.postalCode1'))(value);
  if (isRequiredValidation.error) {
    return [isRequiredValidation.errorMessage];
  }

  const rules = [isValidSwedishPostalCodeFormat(typedT('errorMessages.validation.postalCode2'))];
  return validateRules(rules, value);
};

export const validatePostalCodeInternational = (value: string) => {
  const rules = [isMaxLength(typedT('errorMessages.validation.postalCode3'), 10)];
  return validateRules(rules, value);
};
